import store from './store'
import match from './match'
import notes from './notes'

const namespaced = true

export default {
  namespaced,
  modules: {
    store,
    match,
    notes
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/bioreq/forms/index.js